import { createClient, type SupabaseClient } from '@supabase/supabase-js';

// Conexión con la base. La URL y la llave publishable son públicas por diseño: la seguridad la dan las reglas
// de acceso de la base (solo el equipo, con verificación en dos pasos). Ver supabase/migrations.
const url = import.meta.env.VITE_SUPABASE_URL;
const llave = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase: SupabaseClient | null = url && llave
  ? createClient(url, llave, { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } })
  : null;

export const AMBIENTE: 'pruebas' | 'produccion' = import.meta.env.VITE_AMBIENTE === 'produccion' ? 'produccion' : 'pruebas';
